<template>
  <section class="project-tree-field"
           @mouseup="dragEnd(draggedEl, $event, drugConfig)"
           :class="{'project-tree-field_full': activeFullScreen}">
    <perfect-scrollbar @mouseup="delEvent"
                       @mouseleave="delEvent"
                       @mousedown="mouseDown"
                       @mousemove="treeMousemove"
                       ref="scrollElement"
                       :class="{'dragged-cont': isDown}"
                       class="project-tree-scrollwrap">
      <div class="project-tree-cont"
           :style="{transform: `scale(${Number(scaleIndex).toFixed(2)})`}">
        <div class="project-item project-item_mother projects-dropzone"
             :data-project="motherProject.isMother ? -1 : motherProject.project_id"
             :class="{'empty-projects': isEmpty}">
          <p class="project-name">
            <trim-item :string="motherProject.name" :width="1"></trim-item>
          </p>
          <div class="user-cont" v-if="motherProject.isMother">
            <avatar-cont class="avatar-cont"
                         :editable="false"
                         :width="24"
                         :img-url="motherProject.userAvatar"
                         :height="24"></avatar-cont>
            <div class="name-cont">
              <p class="user-name">
                {{motherProject.userName}}
              </p>
              <p class="user-role">
                {{$t('profile.statuses.admin')}}
              </p>
            </div>
          </div>
          <star-icon v-if="motherProject.isMother"
                     class="star-icon"></star-icon>

          <button type="button"
                  v-if="motherProject.permission_level > 1"
                  @click="addSectionBottom(motherProject.isMother ? motherProject.id : motherProject.project_id)"
                  class="add-btn add-project add-btn-bottom hint-cont">
            <plus-small-icon class="add-project"></plus-small-icon>
            <p class="btn-hint  btn-hint_bottom">
              {{$t('projects.addBottom')}}
            </p>
          </button>
        </div>


        <tree :tree-data="projectsTree"
              v-if="!isEmpty"
              :dragEndFlag="dragEndFlag"
              @changeFlag="dragEndFlag = false"
              :mother-project="motherProject"></tree>


      </div>
    </perfect-scrollbar>

    <div class="hidden-node hidden-project-item"
         :style="{left: `${dragX}px`, top: `${dragY}px`,visibility: hiddenEl ? 'hidden': 'visible', transform: `scale(${Number(scaleIndex).toFixed(2)})`}"
    >
      <div class="project-item hidden-el"
           ref="hiddenEl"
           @mouseup="dragEnd(draggedEl, $event, drugConfig)"
           v-show="draggedEl"
      >
        <div class="project-top" v-if="draggedEl">

          <p class="project-name">
            <trim-item :string="draggedEl.name" :width="17"></trim-item>
          </p>
          <div class="roles-cont">
            <p class="user-name">
              {{$t('projects.project.roles')}}
            </p>
          </div>
          <div class="roles-cont">
            <p class="user-name">
              {{$t('projects.project.sectionsItem')}}:
            </p>
          </div>
        </div>
      </div>
      <ul class="inner-list"

          v-if="draggedEl.items && draggedEl.items.length"
          :class="{'got-items': draggedEl.items.length > 1, 'first_level': isMother(draggedEl), 'inner-list_vertical': draggedEl.levelLength > 1 && !isMother(draggedEl), 'inner-list_horizontal': draggedEl.levelLength <= 1 && !isMother(draggedEl)}"
      >
        <li class="line-item"
            :style="{height: `calc(100% - ${returnHeightLine(draggedEl)}px)`}"
            v-if="draggedEl.levelLength > 1">
        </li>
        <node class="project-show"
              :level="i"
              :mother-project="motherProject"
              :key="'subproject' + project.id"
              v-for="(project,i) in draggedEl.items"
              :node="project"></node>
      </ul>
    </div>

    <tree-control></tree-control>

    <div class="popup-wrap" v-if="verlayShown && activeFullScreen">
      <div class="modal-overlay" v-if="activeFullScreen && verlayShown"></div>
      <del-projects v-if="activeFullScreen && showDelProject"></del-projects>
      <add-section v-if="activeFullScreen && showAddSection"></add-section>
    </div>
  </section>
</template>

<script>
  import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
  import avatarCont from '../../../avatarCont'
  import starIcon from '../../../Svg/projects/goldStar'
  import trimItem from '../../../trimITem'
  import treeControl from './projectControls'
  import tree from './tree'
  import {projectItem} from "../../../../mixins/projects/projectItem";
  import {dragNdrapProjects} from "../../../../mixins/dragNdrop/dragNdropProjects";
  import throttle from '../../../../mixins/utils/throttle'

  import delProjects from '../../../Popups/projects/delProjectItem'
  import addSection from '../../../Popups/projects/addSection'
  import node from '../../../../components/Pages/Project/projectTree/nodeTree'
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";
  import {loaderMixin} from "../../../../mixins/utils/loaderMixin";
  import plusIcon from '../../../../components/Svg/plusIcon'
  import plusSmallIcon from '../../../../components/Svg/plusSmallIcon'
  import {showOverlay} from "../../../../mixins/utils/showOverlay";

  export default {
    name: 'projectTreeField',
    mixins: [projectItem, dragNdrapProjects, tokenAndRoute, loaderMixin, showOverlay],
    components: {
      avatarCont,
      starIcon,
      trimItem,
      treeControl,
      tree,
      delProjects,
      addSection,
      node,
      plusIcon,
      plusSmallIcon
    },
    data() {
      return {
        startX: 0,
        startY: 0,
        isDown: false,
        scrollLeft: 0,
        scrollTop: 0,
        dragEndFlag: false,
      }
    },
    computed: {
      ...mapState({
        project: state => state.projects.singleProject,
        allProjects: state => state.projects.allProjects,
        scaleIndex: state => state.projects.scaleIndex,
        activeFullScreen: state => state.projects.activeZoom,

        showDelProject: state => state.projects.showDelPopup,
        showAddSection: state => state.projects.showAddSection,

        verlayShown: state => state.popups.showOverlay,

        isProjectItem: state => state.projects.isProjectItem,
        isItemProjects: state => state.projects.isItemProjects,
      }),
      ...mapGetters({
        projectsTree: 'projects/projectsTree',
        projectOwner: 'projects/projectOwnerRole'
      }),
      ownerRole() {
        return this.projectOwner(this.project.owner_role_id)
      },
      motherProject() {

        let projectId = this.$route.params.item;

        let obj = {
          name: this.projectsTree.name,
          id:  this.projectsTree.id,
          isMother: false,
          createdAt: this.projectsTree.created_at,
          permission_level: this.projectsTree.permission_level,
          project_id: projectId,
        };
        if (!this.isProjectItem && !this.isItemProjects) {
          obj.userName = `${this.ownerRole.user.first_name ? this.ownerRole.user.first_name : ''} ${this.ownerRole.user.second_name ? this.ownerRole.user.second_name : ''}`;
          obj.userAvatar = this.ownerRole.user.contacts.avatar_url;
          obj.roles = this.projectsTree.permissions.length;
          obj.isMother = true;
          obj.id = this.projectsTree.id;
          obj.project_id = '';
        };

        return obj;
      },
      isEmpty() {
        return this.itemsLength === 0
      },
      itemsLength() {
        if (this.projectsTree) {
          return this.projectsTree.items.length
        } else {
          return 0
        }
      }
    },
    watch: {
      dragX(val) {
        if (this.draggedEl) {
          const element = this.$refs.scrollElement.$el;
          let sizeBlock = document.querySelector('.project-tree-cont').offsetWidth
          let smBlock  = document.querySelector('.project-tree-scrollwrap').offsetWidth
          let num = smBlock / sizeBlock
          function setLeft() {
            element.scrollLeft = val / num
          };
          throttle(setLeft(), 1000);
        }
      },
      dragY(val) {
        if (this.draggedEl) {
          const element = this.$refs.scrollElement.$el;
          let sizeBlock = document.querySelector('.project-tree-cont').offsetHeight
          let smBlock  = document.querySelector('.project-tree-scrollwrap').offsetHeight
          let num = smBlock / sizeBlock
          function setTop() {
            element.scrollTop = val / num
          };
          throttle(setTop(), 1000)
        }
      },
    },
    methods: {
      ...mapMutations({
        setShowControls: 'projects/SET_SHOW_CONTROLS',
        SET_DRAGGED_EL: 'projects/SET_DRAGGED_EL',
        setActiveZoom: 'projects/SET_ACTIVE_ZOOM',
        setActiveTab: 'projects/SET_ACTIVE_HEADER_TAB',
        showAddSectionPopup: 'projects/SET_SHOW_ADD_SECTION',
        setAddId: 'projects/SET_ADD_SECTION_ID_CHILD',

      }),
      ...mapActions({
        moveProjectItem: 'projects/moveItem',
        getProjects: 'projects/getProjects',
        getProject: 'projects/getProject',
      }),
      addSectionBottom(id) {
        this.showOverlay(true);
        this.showAddSectionPopup(true);
        if (!this.motherProject.isMother) {
          this.setAddId(id)
        }
      },
      goToRoles() {
        this.setActiveTab('projectRoles');
        if (this.$route.name.includes('projectItem')) {
          this.$router.push(`/project-edit/${this.$route.params.id}/project-item/${this.$route.params.item}`)
        } else {
          this.$router.push(`/project-edit/${this.$route.params.id}`)
        }
      },
      mouseMove(e,config) {
        //двигаем элемент
        let shiftX = this.movedX;
        let posX = e.pageX - shiftX;

        let shiftY = this.movedY;
        let posY = e.pageY - shiftY;

        this.dragX = posX;
        this.dragY = posY;

        //получаем скрытый элемент
        let hiddenEl = document.querySelector('.hidden-project-item');
        hiddenEl.classList.add('hiddenClass');

        //элемен под перемещаемым
        let elemBelow = document.elementFromPoint(e.clientX, e.clientY);
        hiddenEl.classList.remove('hiddenClass');


        if (!elemBelow) return;
        let droppableBelow = elemBelow.closest(this.drugConfig.dropzone);

        if (this.currentDroppable != droppableBelow) {
          if (this.currentDroppable) {
            //вылет
            this.leaveGroup()
          };
          this.currentDroppable = droppableBelow
          if (this.currentDroppable) {
            //вход
            if (this.currentDroppable.classList.contains('item-blocked')) {
              return;
            };
            this.enterGroup()
          }
        }

      },
      removeAllHandlers() {
        let elems = document.querySelectorAll('.movedClass');

        elems.forEach(item => {
          item.classList.remove('movedClass');
          item.style.left = 0;
          item.style.top = 0;
        });
        let elemsDrop = document.querySelectorAll(`.${this.drugConfig.dropActive}`);
        elemsDrop.forEach(item => {
          item.classList.remove(this.drugConfig.dropActive);
        });

        this.movedEl ='';
        this.movedX = '';
        this.movedY = '';
        this.draggedEl = '';
        this.deltaY = '';
        this.deltaX = '';
        this.dragX = '';
        this.dragY = '';

        document.removeEventListener('mousemove', this.mouseMove);
      },


      isMother(draggedEl) {
        return (draggedEl.name === this.motherProject.name &&
          draggedEl.id === this.motherProject.id &&
          draggedEl.crated_at === this.motherProject.created_at)
      },
      returnHeightLine(node) {
        // так как у последнего может быть несколько предков и линия идет по пизде
        // нужно понять, сколько предков у последнего элемента через вот такую ебанину
        // node.items[node.items.length - 1].items.length
        // после чего сделать линию меньше

        // где n - число предков,
        // h - высота элемента,
        // m - margin = 20px
        const h = 94;
        const m = 20;
        //какая то погрешность в 5px. хуй его знает, откуда она :D
        const delta = 5;

        if (node.items.length && node.items[node.items.length - 1].items.length) {
          const n = node.items[node.items.length - 1].items.length

          if (n === 1) {
            //один элемент с горизонтальной линией
            //высота 1 элемента + его маржин + половина высоты родителя
            return h + m + h/2 + delta
          } else
          {
            //больше одного столбеца
            //n высот дочек + n маржинов дочек + половина высоты родителя
            return (n * h) + (m * n) + h/2 + delta
          }
        } else
        {
          return h/2 + 5
        }
      },
      setDefaultHalfScroll() {
        //устанавливаем скролл посередине, если нужно
        let scrollWidth = this.$refs.scrollElement.$el.scrollWidth;
        this.$refs.scrollElement.$el.scrollLeft = scrollWidth / 2 - 290;
      },
      mouseDown(e) {
        const element = this.$refs.scrollElement.$el;
        //активируем эвент
        this.isDown = true;
        //записываем начальное положение
        this.startX = e.pageX - element.offsetLeft;
        this.startY = e.pageY - element.offsetTop;

        this.scrollLeft = element.scrollLeft;
        this.scrollTop = element.scrollTop;
      },
      treeMousemove(e) {
        if (this.$refs.scrollElement) {
          const element = this.$refs.scrollElement.$el;
          //если эвент неактивен
          if (!this.isDown) return;
          //вычисляем x
          const x = e.pageX - element.offsetLeft;
          //и смещение по X
          const walkX = (x - this.startX);
          //вычисляем y
          const y = e.pageY - element.offsetTop;
          //и смещение по Y
          const walkY = (y - this.startY);
          //устанавливаем скролл
          element.scrollLeft = this.scrollLeft - walkX;
          element.scrollTop = this.scrollTop - walkY;
        }
      },
      delEvent() {
        this.isDown = false;
      },

      async dragEnd(item) {
        let element = document.querySelector('.moved_class-opacity');
        let targetProjectItem = this.movedGroup;

        let mainNode = false // флаг для понятия куда навелись (false - на скрытый блок, true - на существующий)
        let dopNode = {} // объект скрытой ноды на которую навелись

        let parentId = 0;

        // проверяем куда бросаем ноду
        // если на существующую ноду то меняем флаг mainNode на true
        // усли на скрытый блок то заполняем переменную dopNode этим блоком
        let arr = JSON.parse(JSON.stringify(this.dopElemOnDrag))
        let childArr = (items) => {
          items.forEach((item) => {
            if (!item.dopNode && item.id === Number(this.movedGroup)) {
              mainNode = true
            }
            if (item.dopNode && !item.show) {
              dopNode = item
            }
            if (item.items && item.items.length > 0) {
              childArr(item.items)
            }
          })
        }
        if (arr.items.length > 0) {
          childArr(arr.items)
        }

        this.leaveGroup();
        this.removeAllHandlers();

        document.removeEventListener('mousemove', this.mouseMove);

        let projectId;
        projectId = Number(this.routeId)

        if (element) {
          this.showLoader();
          element.classList.remove('moved_class-opacity');
          if (targetProjectItem) {

            let nodeId = 0 // id ноды после которой ставить (если 0 то в начало)

            // если существующая нода то ищем ее массив детей и заполняем nodeId последним элементом (его id)
            // если элементов в массиве нету, то ставим 0
            if (mainNode) {
              if (targetProjectItem !== -1) {
                let nodeFunc = (items) => {
                  items.forEach((item) => {
                    if (item.id === targetProjectItem) {
                      if (item.items.length > 0) {
                        nodeId = item.items[item.items.length - 1].id
                      }
                      if (item.items.length === 0) {
                        nodeId = 0
                      }
                    }
                    if (item.items && item.items.length > 0) {
                      nodeFunc(item.items)
                    }
                  })
                }
                nodeFunc(this.project.items)
              } else {
                nodeId = this.project.items[this.project.items.length - 1].id
              }
            }
            // если это скрытый блок то ищем массив в котором он лежит, потом ищем в изначальном объекте проекта
            // по id родителя, а потом по place ищем сам элемент для записи id проекта и id ноды после которой нужна вставить элемент
            else {
              let searchArr = (items, id) => {
                items.forEach((item) => {
                  if (item.id == dopNode.id) {
                    targetProjectItem = id // заменяем с id на который навелись на id родителя
                    let searchNode = (itemsNode, itemNodeId) => {
                      if (id === itemNodeId) {
                        if (dopNode.place === 0) {
                          nodeId = 0
                        } else {
                          nodeId = itemsNode[dopNode.place - 1].id
                        }
                      }
                      itemsNode.forEach((itemNode) => {
                        if (itemNode.items && itemNode.items.length > 0) {
                          searchNode(itemNode.items, itemNode.id)
                        }
                      })
                    }
                    if (id === this.project.id) {
                      if (dopNode.place === 0) {
                        nodeId = 0
                      } else {
                        nodeId = this.project.items[dopNode.place - 1].id
                      }
                    } else {
                      searchNode(this.project.items)
                    }
                  }
                  if (item.items && item.items.length > 0) {
                    searchArr(item.items, item.id)
                  }
                })
              }
              if (arr.items.length > 0) {
                searchArr(arr.items, arr.id)
              }
            }

            if (this.project.id === Number(targetProjectItem)) {
              parentId = -1
            } else {
              parentId = Number(targetProjectItem)
            }

            let data = {
              id: item.id, // id перетаскиваемого элемента
              place_after_id: nodeId, // id после которого нужно поставить (если передеем 0 то ставим в начало)
              parent_item_id: parentId // id родителя куда нужно поставить
            };


            if (data.id !== data.parent_item_id && data.id !== data.place_after_id) {
              await this.moveProjectItem(data).then(() => {
                this.getProjects().then(() => {
                  this.getProject(projectId);
                  this.clearAll();
                  this.hideLoader();
                })
              })
            } else if (data.id === data.place_after_id) {
              this.allProjects.forEach(project => {
                if (project.id === this.motherProject.id) {
                  project.items.forEach(item => {
                    if (item.id !== data.place_after_id) {
                      data.place_after_id = item.id
                    }
                  })
                }
              })

              await this.moveProjectItem(data).then(() => {
                this.getProjects().then(() => {
                  this.getProject(projectId);
                  this.clearAll();
                  this.hideLoader();
                })
              })
            }

            else if (data.id === data.parent_item_id) {
              data.parent_item_id = -1
              data.place_after_id = 0
              await this.moveProjectItem(data).then(() => {
                this.getProjects().then(() => {
                  this.getProject(projectId);
                  this.clearAll();
                  this.hideLoader();
                })
              })
            }

          } else {
            this.clearAll();
            this.hideLoader();
          }
        };
        this.dragEndFlag = true

      }
    },
    mounted() {
      this.setDefaultHalfScroll();
    },

  }
</script>

<style lang="scss" scoped>
  $line: #6194AF;

  .dragged-cont {
    cursor: move;
  }

  .project-tree-field {
    border-radius: 8px;
    width: 100%;
    height: calc(100vh - 218px);
    background: rgba(233, 240, 244, 1);
    padding-bottom: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .project-tree-field_full {
    height: calc(100vh - 68px);
  }

  .project-tree-scrollwrap {
   // overflow-x: scroll;
    width: 100%;
    height: 100%;
    padding: 22px 30px;
    position: relative;



   // @include scrollField(2px)
  }

  .project-item {
    background: white;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0px 1px 0px #F5F8FA;
    border: 1px solid #F5F8FA;
    width: 180px;
    //position: absolute;
    //margin-top: 20px;
    min-height: 80px;
    //margin-left: 20px;
    //margin-right: 20px;
    user-select: none;
  }

  .project-item_mother {
    position: relative;
    margin: 0 auto;
    margin-bottom: 20px;




    &::before {
      content: '';
      position: absolute;
      background: $line;
      left: 50%;
      width: 1px;
      height: 20px;
      bottom: auto;
      top: calc(100% + 2px);
    }

    .star-icon {
      position: absolute;
      top: 6px;
      right: 6px;
    }

    &.empty-projects::before {
      display: none;
    }
  }



  .project-name {
    font-family: $msb;
    font-size: 12px;
    letter-spacing: .25px;
    margin-bottom: 16px;
  }

  .user-cont {
    display: flex;
    align-items: center;
    margin-bottom: 3px;
  }

  .avatar-cont {
    margin-right: 8px;

    img {
      width: auto;
      height: 100%;
    }
  }

  .user-name {
    font-family: $mm;
    font-size: 12px;
    margin-bottom: 2px;
  }

  .user-role {
    font-family: $mm;
    font-size: 8px;
    opacity: .6;
  }

  .projects-list {
    display: flex;
    justify-content: center;
    margin-left: -20px;
    margin-right: -20px;
  }

  .project-tree-cont {
    width: fit-content;
    min-width: calc(100% - 60px);
    position: absolute;
    top: 22px;
    left: 30px;
    padding-bottom: 30px;
  }

  /*.projects-tree-wrap {
    position: relative;
    padding-top: 7px;
    margin: 0 auto;
    width: fit-content;


    &::before {
      content: '';
      position: absolute;
      width: calc(100% - 181px);
      height: 90px;
      left: 90px;
      top: 0;
      border-top: 1px solid $line;
      border-left: 1px solid $line;
      border-right: 1px solid $line;
      border-radius: 8px;
    }
  }

  .project-tree-wrap_single {
    padding-top: 0;
    &::before {
      display: none;
    }
  }*/

  .project-name {
    width: 100%;
  }

  .roles-cont {
    margin-bottom: 6px;
    display: flex;
    align-items: center;

    .user-role-count {
      color: #29ABE2;
      font-family: MM, Arial, sans-serif;
      font-size: 12px;
      margin-left: 10px;
    }
  }

  .hiddenClass {
    visibility: hidden!important;
  }
</style>

<style lang="scss" scoped>
  $line: #6194AF;

  .line-item {
    position: absolute;
    width: 1px;
    background: $line;
    left: 0;
    top: 0;

    &::before {
      content: url('../../../../assets/angle.svg');
      position: absolute;
      width: 14px;
      height: 14px;
      left: 0;
      bottom: -6px;
    }
  }

  .hidden-node {
    position: absolute;
    height: auto;
  }
  .got-items {
    /*&:before {
      content: '';
      position: absolute;
      width: calc(100% - 220px);
      height: 90px;
      left: 110px;
      top: 0;
      border-top: 1px solid $line;
      border-left: 1px solid $line;
      border-right: 1px solid $line;
      border-radius: 8px;
    }*/
  }
  .inner-list {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-left: -20px;
    //position: absolute;
    .pseudo-block {
      height: 114px;
      background: none;
    }
  }

  .inner-list_vertical {
    flex-direction: column;
    /*transform: translateX(30px);*/
    margin-left: 30px;
    position: absolute;
  }

  .inner-list_vertical > .project-node:last-of-type > .project-item:last-of-type {
    &::before {
      width: 15px;
    }
  }

  .inner-list_horizontal > .project-node:last-of-type > .project-item:last-of-type {
    &::before {
      width: 1px;
    }
  }


  .inner-list_vertical > .project-node >  .project-item {
    &::before {
      width: 20px;
      height: 1px;
      right: 100%;
      left: auto;
      top: 50%;
      bottom: auto;
    }


  }


  .inner-list_horizontal > .project-node > .project-item {
    &::before {
      content: '';
      position: absolute;
      width: 1px;
      height: 20px;
      background: $line;
      left: calc(50% - 0.5px);
      top: auto;
      bottom: calc(100% + 1px);
    }
  }


  .add-btn {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid $lightBlue;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 8;
    display: flex;
    display: none;

    &:hover {
      border-color: white;
      background: $lightBlue;
    }
  }

  .add-btn-right {
    right: -8px;
    top: calc(50% - 8px);

  }

  .add-btn-bottom {
    bottom: -8px;
    right: calc(50% - 8px);
  }

  .project-item_mother:hover {
    .add-btn {
      display: flex;
    }
  }

  .projects-drop {
    opacity: .5!important;
  }
</style>
